import { defineAsyncComponent } from 'vue'
export default {
  default: defineAsyncComponent(() => import("/app/frontend/layouts/default.vue").then(m => m.default || m)),
  plain: defineAsyncComponent(() => import("/app/frontend/layouts/plain.vue").then(m => m.default || m)),
  preview: defineAsyncComponent(() => import("/app/frontend/layouts/preview.vue").then(m => m.default || m))
}